export const getSuccessPageContent = () => ({
  requestTitle: 'success-page-request-title',
  orderTitle: 'success-page-order-title',
  metaDescription: 'success-page-meta-desc',
})
